import { render, staticRenderFns } from "./update-stock-details.vue?vue&type=template&id=eba0e6b4&scoped=true"
import script from "./update-stock-details.vue?vue&type=script&lang=js"
export * from "./update-stock-details.vue?vue&type=script&lang=js"
import style0 from "./update-stock-details.vue?vue&type=style&index=0&id=eba0e6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba0e6b4",
  null
  
)

export default component.exports